export { default as Img200 } from './processed/200/MadMax.jpg';
export { default as Img400 } from './processed/400/MadMax.jpg';
export { default as Imgthumb } from './processed/thumb/MadMax.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/MadMax.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/MadMax.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      247,
      186,
      4
    ],
    "_population": 2464,
    "_hsl": [
      0.12482853223593963,
      0.9681274900398406,
      0.49215686274509807
    ]
  },
  "LightVibrant": {
    "_rgb": [
      231,
      195,
      156
    ],
    "_population": 896,
    "_hsl": [
      0.08666666666666663,
      0.6097560975609755,
      0.7588235294117647
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      204,
      170,
      4
    ],
    "_population": 287,
    "_hsl": [
      0.13833333333333328,
      0.9615384615384617,
      0.40784313725490196
    ]
  },
  "Muted": {
    "_rgb": [
      119,
      126,
      136
    ],
    "_population": 678,
    "_hsl": [
      0.5980392156862745,
      0.06666666666666665,
      0.5
    ]
  },
  "LightMuted": {
    "_rgb": [
      196,
      166,
      146
    ],
    "_population": 6,
    "_hsl": [
      0.0666666666666667,
      0.29761904761904767,
      0.6705882352941177
    ]
  },
  "DarkMuted": {
    "_rgb": [
      74,
      67,
      48
    ],
    "_population": 1417,
    "_hsl": [
      0.12179487179487179,
      0.2131147540983607,
      0.23921568627450981
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/MadMax.js